import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import Calendario from './Calendario/Calendario';
import DiaModalComponent from './Calendario/DiaModalComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faAngleLeft, faAngleRight
} from '@fortawesome/free-solid-svg-icons'

import { useSelector, useDispatch } from 'react-redux'
import { obtenerDiasByIdZona } from '../../redux/DucksUnidadInspeccion/MesZonaDuck';
import { getZonas } from '../../redux/DucksUnidadInspeccion/ZonasDuck';


function PanelCalendario(props) {

    const idTipoUsuario = useSelector(store => store.Usuario.tipoUsuario)

    const dispatch = useDispatch()

    /** DATOS DUMMY DE INSPECTORES Y EMPRESAS */
    const inspectores = [{ id: 1, nombre: "Juan Roman Riquelme", info: "Alguna informacion en especifico", zona: "alguna zona" },
    { id: 2, nombre: "Roberto Carlos", info: "Alguna informacion en especifico", zona: "alguna zona" },
    { id: 3, nombre: "Raul Gonzales Blanco", info: "Alguna informacion en especifico", zona: "alguna zona" }]

    const domicilios = [{ id: 1, empresa: "Empresa 1", domicilio: "Domicilio 1", info: "Alguna informacionde la empresa y/o domiclio" },
    { id: 2, empresa: "Empresa 2", domicilio: "Domicilio 2", info: "Alguna informacionde la empresa y/o domiclio" },
    { id: 3, empresa: "Empresa 3", domicilio: "Domicilio 3", info: "Alguna informacionde la empresa y/o domiclio" }]

    const [modalShow, setModalShow] = React.useState(false);
    const [infoModal, setInfoModal] = React.useState({})
    const [inspectoresZonas, setInspectoresZonas] = React.useState(null)

    const [zonas, setZonas] = React.useState([]);

    const zonasDuck = useSelector(store => store.Zonas.zonas)

    const [zonaActual, setZonaActual] = React.useState(null);

    const zonaAnterior = () => {
        if (zonasDuck[zonaActual.idzona - 2] != undefined) {

            let index = zonaActual.idzona - 1;
            if (index > -1) {
                //dispatch(obtenerZonaInspectorByIdZona(zonaActual.numeroDeZona))
                dispatch(obtenerDiasByIdZona(zonaActual.idzona)).then((res) => {

                })
                setZonaActual(zonasDuck[index - 1])
            }
        }
    }

    const zonaSiguiente = () => {
        if (zonasDuck[zonaActual.idzona] != undefined) {
            let index = zonaActual.idzona;
            if (index < 21) {
                //dispatch(obtenerZonaInspectorByIdZona(zonaActual.numeroDeZona))
                setZonaActual(zonasDuck[index])
                dispatch(obtenerDiasByIdZona(zonaActual.idzona)).then((res) => {
                })
            }
        }
    }

    const actualizarDias = (zona) => {
        if (zona.idzona != null) {
            setZonaActual(zona)
            dispatch(obtenerDiasByIdZona(zona.idzona)).then((res) => {

            })
        }
    }


    const handleDia = (info) => {
        if (idTipoUsuario === 4) {
            setModalShow(true)
            setInfoModal(info)
        } else if (idTipoUsuario === 5) {
            props.history.push('/PanelVisitasForm', {
                state: {
                    inspectores,
                    domicilios,
                    fechaSeleccionada: info
                }
            })
        }
    }

    const actualizarZonas = () => {
        dispatch(getZonas()).then((res) => {
            setZonaActual(res.payload.data.data[0])
        })
    }

    useEffect(() => {
        dispatch(getZonas()).then((res) => {
            setZonaActual(res.payload.data.data[0])
        })
    }, []);

    useEffect(() => {
        zonaActual
    }, [zonaActual]);

    return (
        <Fragment><br />
            <div className='container'>
                <div className='row text-center'>
                    <div className='col-md-1 text-center'>
                        <button onClick={zonaAnterior} className={`badge bg-success text-light`} ><FontAwesomeIcon icon={faAngleLeft} /><br />zona anterior</button>
                    </div>
                    <div className='col-md-10 text-center'>
                        <h1>Zona: <strong>{zonaActual?.nombrezona} </strong></h1>
                        {/* <h4>Credencial:  C-141.21</h4> */}
                    </div>
                    <div className='col-md-1 text-center'>
                        <button onClick={zonaSiguiente} className={`badge bg-success text-light`} ><FontAwesomeIcon icon={faAngleRight} /><br />zona siguiente</button>
                    </div>
                </div>

                <Calendario handleModal={handleDia} zona={zonaActual} actualizarZonas={actualizarZonas} actualizarDias={actualizarDias}></Calendario>

                <DiaModalComponent
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    info={infoModal}
                />
            </div>
        </Fragment>
    );
};


export default withRouter(PanelCalendario)
